import { FaTshirt, FaToiletPaper, FaSuitcase, FaPlug, FaCampground, FaUtensils, FaWrench, FaBoxes } from "react-icons/fa";

export const initialCategoryItems = {
  Essentials: [
    { name: "Passport", completed: false },
    { name: "Wallet", completed: false },
    { name: "Keys", completed: false },
  ],
  Clothes: [
    { name: "T-shirt", completed: false },
    { name: "Jeans", completed: true },
    { name: "Sweater", completed: true },
    { name: "Underwear", completed: false },
    { name: "Socks", completed: false },
    { name: "Jacket", completed: false },
  ],
  Toiletries: [
    { name: "Toothbrush", completed: false },
    { name: "Toothpaste", completed: false },
    { name: "Shampoo", completed: false },
  ],
  Electronics: [
    { name: "Phone Charger", completed: false },
    { name: "Laptop", completed: false },
  ],
  "Shared packing": [
    { name: "First aid kit", completed: false },
    { name: "Snacks", completed: false },
  ],
};

export const categories = [
  "Travel Essentials",
  "Clothing & Footwear",
  "Toiletries & Hygiene",
  "Electronics",
  "Camping Equipment",
  "Cooking & Food Supplies",
  "Tools & Equipment",
  "Miscellaneous"
];

export const getIconForCategory = (category) => {
  switch (category) {
    case "Travel Essentials":
      return FaSuitcase;
    case "Clothing & Footwear":
      return FaTshirt;
    case "Toiletries & Hygiene":
      return FaToiletPaper;
    case "Electronics":
      return FaPlug;
    case "Camping Equipment":
      return FaCampground;
    case "Cooking & Food Supplies":
      return FaUtensils;
    case "Tools & Equipment":
      return FaWrench;
    case "Miscellaneous":
      return FaBoxes;
    default:
      return FaSuitcase;
  }
};

export const calculatePercentage = (categoryItems) => {
  if (!categoryItems || !Array.isArray(categoryItems)) return 0;
  const totalItems = categoryItems.length;
  const completedItems = categoryItems.filter((item) => item.completed).length;
  return totalItems === 0 ? 0 : (completedItems / totalItems) * 100;
};
